module.exports = __webpack_public_path__ + "static/media/dekton-white.6373abe2.svg";